import { firestoreService } from '../services/firestoreService';

// Firebase Functions base URL - removed trailing slash
const FUNCTIONS_BASE_URL = window._ENV_.REACT_APP_FIREBASE_FUNCTIONS_URL;

export const createSetupIntent = async ({
  donorDetails,
  paymentMethodType,
  intervalDescription
}) => {
  try {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/createSetupIntent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        donorDetails,
        paymentMethodType,
        intervalDescription
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create setup intent');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating setup intent:', error);
    throw error;
  }
};

export const scheduleDonations = async (payload) => {
  try {
    // Store scheduled donation in Firestore
    const scheduleId = await firestoreService.addDocument('donationSchedules', {
      ...payload,
      status: 'pending'
    });
    
    return { scheduleId, ...payload };
  } catch (error) {
    console.error('Error scheduling donations:', error);
    throw error;
  }
};

export const getSchedule = async (scheduleId) => {
  try {
    return await firestoreService.getDocument('donationSchedules', scheduleId);
  } catch (error) {
    console.error('Error fetching schedule:', error);
    throw error;
  }
};

export const cancelSchedule = async (scheduleId) => {
  try {
    await firestoreService.updateDocument('donationSchedules', scheduleId, {
      status: 'cancelled',
      cancelledAt: new Date()
    });
    
    return { scheduleId, status: 'cancelled' };
  } catch (error) {
    console.error('Error cancelling schedule:', error);
    throw error;
  }
};

export const pauseSchedule = async (scheduleId, pausedUntil) => {
  try {
    await firestoreService.updateDocument('donationSchedules', scheduleId, {
      pausedUntil: pausedUntil,
      status: 'paused'
    });

    return { scheduleId, status: 'paused', pausedUntil: pausedUntil };
  } catch (error) {
    console.error('Error pausing schedule:', error);
    throw error;
  }
};

export const resumeSchedule = async (scheduleId) => {
  try {
    await firestoreService.updateDocument('donationSchedules', scheduleId, {
      pausedUntil: null,
      status: 'pending'
    });

    return { scheduleId, status: 'pending', pausedUntil: null };
  } catch (error) {
    console.error('Error resuming schedule:', error);
    throw error;
  }
};

export const createPaymentIntent = async (payload) => {
  try {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/createPaymentIntent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create payment intent');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};
